import { EVENT_ACTIONS, EVENT_DOMAINS, EVENT_SCREENS, EVENT_TYPES } from '../../../lib/analytics/constants';
import logger from '../../../lib/analytics/logger';
import { BATTLES_EVENT_TYPES } from '../constants';
export var sendBattlesEvent = function sendBattlesEvent(eventType) {
  switch (eventType) {
    case BATTLES_EVENT_TYPES.ENTER_BATTLES_SCREEN:
      logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.DISPLAY,
        domain: EVENT_DOMAINS.BATTLES,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].MAIN
      });
      break;
    default:
      break;
  }
};